import React, { useEffect} from 'react';

import './ClapprPlayer.css';
import { useScript } from '../../../data/util/customHooks';

export default function ClapprPlayer(props){
    const scriptStatus = useScript(props.playerUrl || 'https://www.streamingwebtv24.it/swtv24jsdomusbet/clappr.min.js', false);
	//  player url
    useEffect(() => {
        if (typeof window.Clappr !== 'undefined' && scriptStatus == 'ready'  && props.streamSource  ) {
	        	window.clapprPlayerObject = new window.Clappr.Player({
	                source:props.streamSource,
	                parentId: "#clappr",
	                width: '100%',
	                height: '100%',
	                autoPlay: true,
	                mute: true
	            });
        }
      }, [scriptStatus, props.streamSource])


    return (
        <div id="clappr"></div>
    )

}